"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertStyleOverride = exports.strongSuccess = exports.strongError = exports.strongWarning = exports.strongInfo = exports.commonStrongStyles = exports.flatNeutral = exports.flatSuccess = exports.flatError = exports.flatWarning = exports.flatSecondary = exports.flatPrimary = exports.flatWhite = exports.elevatedNeutral = exports.elevatedSuccess = exports.elevatedError = exports.elevatedWarning = exports.elevatedSecondary = exports.elevatedPrimary = exports.elevatedWhite = exports.alertDefaultProps = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️
 * Changing shared code can have unintended consequences for all brands.
 * Please double check with the team before making changes here.
 * If brand specific changes are needed, they should be made in the brand's theme file.
 */
var Info_1 = __importDefault(require("@mui/icons-material/Info"));
var Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
var CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
var material_1 = require("@mui/material");
exports.alertDefaultProps = {
    iconMapping: {
        success: (0, jsx_runtime_1.jsx)(CheckCircle_1.default, {}),
        info: (0, jsx_runtime_1.jsx)(Info_1.default, {}),
        warning: (0, jsx_runtime_1.jsx)(Warning_1.default, {}),
        error: (0, jsx_runtime_1.jsx)(Info_1.default, {}),
    },
};
var commonElevatedStyles = {
    minWidth: '16rem',
    borderRadius: '0.25rem',
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 6px 10px rgba(0, 0, 0, 0.14)',
};
exports.elevatedWhite = {
    props: { variant: 'elevatedWhite' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonElevatedStyles), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"), backgroundColor: "var(--background-white, ".concat(theme.palette.backgrounds.white, ")") }));
    },
};
exports.elevatedPrimary = {
    props: { variant: 'elevatedPrimary' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonElevatedStyles), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), backgroundColor: "var(--info-300, ".concat(theme.palette.info.light, ")") }));
    },
};
exports.elevatedSecondary = {
    props: { variant: 'elevatedSecondary' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonElevatedStyles), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"), backgroundColor: "var(--primary-300, ".concat(theme.palette.primary.light, ")") }));
    },
};
exports.elevatedWarning = {
    props: { variant: 'elevatedWarning' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonElevatedStyles), { color: "var(--neutrals-900, ".concat(theme.palette.text.secondary, ")"), backgroundColor: "var(--warning-300, ".concat(theme.palette.warning.light, ")") }));
    },
};
exports.elevatedError = {
    props: { variant: 'elevatedError' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonElevatedStyles), { color: "var(--error-700, ".concat(theme.palette.error.dark, ")"), backgroundColor: "var(--error-300, ".concat(theme.palette.error.light, ")") }));
    },
};
exports.elevatedSuccess = {
    props: { variant: 'elevatedSuccess' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonElevatedStyles), { color: "var(--neutrals-900, ".concat(theme.palette.text.secondary, ")"), backgroundColor: "var(--success-300, ".concat(theme.palette.success.light, ")") }));
    },
};
exports.elevatedNeutral = {
    props: { variant: 'elevatedNeutral' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonElevatedStyles), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"), backgroundColor: "var(--background-neutral, ".concat(theme.palette.backgrounds.neutral, ")") }));
    },
};
var commonFlatStyles = {
    minWidth: '16rem',
    borderRadius: '0.25rem',
};
exports.flatWhite = {
    props: { variant: 'flatWhite' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonFlatStyles), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"), backgroundColor: "var(--background-white, ".concat(theme.palette.backgrounds.white, ")"), border: "1px solid var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")") }));
    },
};
exports.flatPrimary = {
    props: { variant: 'flatPrimary' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign({}, commonFlatStyles), (_b = { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"), backgroundColor: "var(--info-300, ".concat(theme.palette.info.light, ")"), border: "1px solid var(--info-700, ".concat(theme.palette.info.dark, ")") }, _b["& .".concat(material_1.alertClasses.icon)] = {
            color: "var(--primary-500, ".concat(theme.palette.primary.main, ")"),
        }, _b)));
    },
};
exports.flatSecondary = {
    props: { variant: 'flatSecondary' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonFlatStyles), { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"), backgroundColor: "var(--primary-300, ".concat(theme.palette.primary.light, ")"), border: "1px solid var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")") }));
    },
};
exports.flatWarning = {
    props: { variant: 'flatWarning' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonFlatStyles), { color: "var(--neutrals-900, ".concat(theme.palette.text.secondary, ")"), backgroundColor: "var(--warning-300, ".concat(theme.palette.warning.light, ")"), border: "1px solid var(--warning-700, ".concat(theme.palette.warning.dark, ")") }));
    },
};
exports.flatError = {
    props: { variant: 'flatError' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonFlatStyles), { color: "var(--error-700, ".concat(theme.palette.error.dark, ")"), backgroundColor: "var(--error-300, ".concat(theme.palette.error.light, ")"), border: "1px solid var(--error-700, ".concat(theme.palette.error.dark, ")") }));
    },
};
exports.flatSuccess = {
    props: { variant: 'flatSuccess' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, commonFlatStyles), { color: "var(--neutrals-900, ".concat(theme.palette.text.secondary, ")"), backgroundColor: "var(--success-300, ".concat(theme.palette.success.light, ")"), border: "1px solid var(--success-700, ".concat(theme.palette.success.dark, ")") }));
    },
};
exports.flatNeutral = {
    props: { variant: 'flatNeutral' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign({}, commonFlatStyles), (_b = { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"), backgroundColor: "var(--background-neutral, ".concat(theme.palette.backgrounds.neutral, ")"), border: "1px solid var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")") }, _b["& .".concat(material_1.alertClasses.icon)] = {
            color: "var(--primary-500, ".concat(theme.palette.primary.main, ")"),
        }, _b)));
    },
};
exports.commonStrongStyles = {
    minWidth: '16rem',
    borderRadius: '0.25rem',
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 6px 10px rgba(0, 0, 0, 0.14)',
};
exports.strongInfo = {
    props: { variant: 'strongInfo' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.commonStrongStyles), { color: "var(--text-light, ".concat(theme.palette.text.light, ")"), backgroundColor: "var(--secondary-700, ".concat(theme.palette.secondary.dark, ")") }));
    },
};
exports.strongWarning = {
    props: { variant: 'strongWarning' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.commonStrongStyles), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), backgroundColor: "var(--warning-700, ".concat(theme.palette.warning.dark, ")") }));
    },
};
exports.strongError = {
    props: { variant: 'strongError' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.commonStrongStyles), { color: "var(--text-light, ".concat(theme.palette.text.light, ")"), backgroundColor: "var(--error-700, ".concat(theme.palette.error.dark, ")") }));
    },
};
exports.strongSuccess = {
    props: { variant: 'strongSuccess' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, exports.commonStrongStyles), { color: "var(--text-light, ".concat(theme.palette.text.light, ")"), backgroundColor: "var(--success-700, ".concat(theme.palette.success.dark, ")") }));
    },
};
exports.alertStyleOverride = (_a = {},
    _a["& .".concat(material_1.alertClasses.message)] = {
        alignSelf: 'center',
    },
    _a);
